import React from "react";
import { Box, Typography, Button } from "@mui/material";
import {useNavigate} from "react-router";
import {Trans} from "react-i18next";

export default function NotFoundPage() {
    const navigate = useNavigate();

    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            height="100%"
            textAlign="center"
            p={4}
        >
            <Box sx={{display: 'flex', pb: 4}}>
                <Typography variant="h1" fontSize={100}>
                    <Trans i18nKey={'notFoundPage.emoji1'}>⛺🚶‍➡️</Trans>
                </Typography>
                <Typography variant="body" fontSize={20}>
                    <Trans i18nKey={'notFoundPage.emoji2'}>🦋️</Trans>
                </Typography>
            </Box>
            <Typography variant="h3" gutterBottom sx={{fontWeight: 400}}>
                <Trans i18nKey={'notFoundPage.404'}>404 - Page Not Found</Trans>
            </Typography>
            <Typography variant="h5" color="text.secondary" gutterBottom>
                <Trans i18nKey={'notFoundPage.firstLine'}>This page got distracted and wandered off...</Trans>
            </Typography>
            <Typography variant="body1" color="text.secondary" mb={4}>
                <Trans i18nKey={'notFoundPage.secondLine'}>We sent a search party. They're also lost now.</Trans>
            </Typography>
            <Button
                variant="contained"
                color="primary"
                onClick={() => navigate("/")}
            >
                <Trans i18nKey={'notFoundPage.homeButton'}>Take me home, I'm scared</Trans>
            </Button>
        </Box>
    );
}